import type { GameState } from '../../types/GameState'
import { UpgradeTypes } from '../values/upgrades/enums'
import departments from '../values/departments'
import allUpgrades from '../values/upgrades'

export default function getDebtPerSecond(gameState: GameState): bigint {
	const { purchases, upgrades } = gameState

	const totalDebtPerSecond =
		purchases.reduce((acc, purchase) => {
			const department = departments[purchase.id]
			if (!department) return acc

			// Count how many upgrades have the TwoExponentRise effect for this department
			const exponentCount =
				upgrades?.reduce((count, upgradeId) => {
					const foundUpgrade = allUpgrades.find((u) => u.id === upgradeId)
					if (!foundUpgrade) return count
					return (
						count +
						foundUpgrade.effects.filter(
							(effect) =>
								effect.results.includes(UpgradeTypes.TwoExponentRise) &&
								effect.for.includes(purchase.id)
						).length
					)
				}, 0) ?? 0

			const multiplier = 2n ** BigInt(exponentCount)

			return (
				acc +
				BigInt(department.baseDebtPerSecond) *
					multiplier *
					BigInt(purchase.quantity)
			)
		}, 0n) *
		(BigInt(gameState.currentPrestigeLevels ?? 0) + 1n)

	return totalDebtPerSecond
}
